import { Permission } from '@traton/devportal-rbac-common-lib';

export const portalgroupsReadPermission: Permission = {
  name: 'portalgroups.read',
  description: 'Allows reading portal groups',
};
export const portalgroupsCreatePermission: Permission = {
  name: 'portalgroups.create',
  description: 'Allows creating portal groups',
};
export const portalgroupsUpdatePermission: Permission = {
  name: 'portalgroups.update',
  description: 'Allows updating portal groups',
};
export const portalgroupsDeletePermission: Permission = {
  name: 'portalgroups.delete',
  description: 'Allows deleting portal groups',
};
